import type { AdminLookupFilter } from '@tyro/api';

export const adminKeys = {
  all: ['admin'] as const,
  tenants: () => [...adminKeys.all, 'tenants'] as const,
  people: (tenantId: number) => [...adminKeys.all, 'people', tenantId] as const,
  userLookup: (filter: AdminLookupFilter) =>
    [...adminKeys.all, 'userLookup', filter] as const,
};
